export const EDITOR_PLUGINS = [
  "advlist autolink lists link image charmap print preview anchor",
  "searchreplace visualblocks code fullscreen",
  "insertdatetime media table paste code wordcount"
];

export const EDITOR_TOOLBAR =
  "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile pageembed template link codesample | a11ycheck ltr rtl | showcomments addcomment";

export const EDITOR_API_KEY = process.env.VUE_APP_TINY_API_KEY;
